const DEV_SERVICE_WORKER_SUFFIXES = ['/custom-service-worker.js', '/sw.js', '/service-worker.js', '/service_worker.js'];

export const DEV_SERVICE_WORKER_RELOAD_FLAG = 'infra-struktur:dev-service-worker-cleanup';

export const shouldRunDevServiceWorkerCleanup = (isDev: boolean, mode: string | undefined): boolean =>
	isDev && mode !== 'pwa';

const resolveServiceWorkerPathname = (scriptUrl: string): string => {
	if (scriptUrl.length === 0) {
		return '';
	}

	try {
		return new URL(scriptUrl, 'http://localhost').pathname;
	} catch {
		return scriptUrl.split(/[?#]/u, 1)[0] ?? '';
	}
};

export const shouldUnregisterDevServiceWorker = (scriptUrl: string): boolean =>
	DEV_SERVICE_WORKER_SUFFIXES.some((suffix) => resolveServiceWorkerPathname(scriptUrl).endsWith(suffix));
